import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AppContext } from '../../../common/public-api';
import { AppUpdateDetectionService } from '../../../core/services';
import { RouteStateService } from '../../../core/services/route-state.service';
import { UserTraceLogService } from '../../services';
import { AuditInfoService } from '../../services/auditInfo.service';
import { LoaderService } from '../loader/loader.service';
import { ToastService } from '../toast/toast.service';
import { ComponentBaseComponent } from './component-base.component';

/**
 * Page component base class
 *
 * @export
 * @abstract
 * @class PageBaseComponent
 * @extends {ComponentBaseComponent}
 */
@Component({
  template: '',
})
export abstract class PageBaseComponent extends ComponentBaseComponent {
  protected _router: Router;
  protected _toastService: ToastService;
  protected _loaderService: LoaderService;
  protected _appContext: AppContext;
  protected _auditInfoService: AuditInfoService;
  protected _routeStateService: RouteStateService;
  protected _userTraceLogService: UserTraceLogService;
  protected _appUpdateDetectionService: AppUpdateDetectionService;

  constructor(injector: Injector) {
    super(injector);
    this._router = injector.get(Router);
    this._toastService = injector.get(ToastService);
    this._loaderService = injector.get(LoaderService);
    this._appContext = injector.get(AppContext);
    this._auditInfoService = injector.get(AuditInfoService);
    this._routeStateService = injector.get(RouteStateService);
    this._userTraceLogService = injector.get(UserTraceLogService);
    this._appUpdateDetectionService = injector.get(AppUpdateDetectionService);
  }

  get formats(): any {
    return this._appContext.envConfig?.format;
  }
  get loaderService() {
    return this._loaderService;
  }
  get routeStateService() {
    return this._routeStateService;
  }
  ngOnDestroy(): void {
    this._userTraceLogService.clearAllTraceLog();
  }
  ngAfterViewInit(): void {
    if (this._appUpdateDetectionService.isEnabled) {
      this._appUpdateDetectionService.checkForUpdates();
      this._appUpdateDetectionService.versionSubject.subscribe({
        next: (result) => {
          this._appUpdateDetectionService.loadNewAppVersion();
        },
      });
    }
  }
}
